<template>
	<div class="shop qjc-relative">
		<ul class="list qjc-clearfix">
			<li v-for="item in list" :key="item.title" class="qjc-fl">
				<img @click="to(item.url)" class="qjc-wid-100" :src="require('@/assets/images/'+ item.img +'.png')" alt="商品展示圖">
				<h4 @click="to(item.url)" class="qjc-fts-30 qjc-c-fff qjc-texta-l">{{ item.title }}</h4>
			</li>
		</ul>
		
		<create-code language="HK"></create-code>
		
	</div>
</template>

<script>
	import createCode from '@/components/createCode'
	
	export default{
		name: 'HKshop',
		data() {
			return {
				list: [
					{ title: '魚躍(YUWELL)低頻理療儀', img: 'yuwell', url: 'https://item.jd.com/100002314515.html' },
					{ title: '歐姆龍溫熱電極式低頻理療儀', img: 'omron', url: 'https://item.jd.com/100006108643.html' },
					{ title: '歐姆龍電子血壓計', img: 'omron_hem7124', url: 'https://item.jd.com/1726938.html' },
					{ title: 'Move Free益節 氨糖維骨力', img: 'schiff', url: 'https://item.jd.hk/100009287096.html' },
					{ title: 'Swisse斯維詩 奶薊草護肝片', img: 'swisse', url: 'https://item.jd.hk/1909882.html' },
					{ title: '金鈣爾奇 碳酸鈣維D3元素片', img: 'gaierqi', url: 'https://item.yiyaojd.com/4397416.html' },
					{ title: '三諾血糖試紙測試儀', img: 'sinocare', url: 'https://item.jd.com/4737030.html' },
					{ title: 'Swisse斯維詩男士複合維生素', img: 'swisse2', url: 'https://item.jd.hk/1909867.html' }
				]
			}
		},
		components: {
			createCode
		},
		methods: {
			to(url) {
				window.location.href = url;
			}
		}
		
	}
</script>

<style lang="scss" scoped>
	.shop{
		height: 9.9rem;
		background: url(https://meidn-image.oss-cn-beijing.aliyuncs.com/file/2020/home_bg.png) no-repeat;
		background-size: 100% 100%;
		
		.list{
			height: 100%;
			padding: 0.44rem 0.68rem;
			overflow: auto;
			
			li{
				width: 25%;
				padding: 0.16rem 0.1rem;
				overflow: hidden;
				
				img{
					height: 4.22rem;
				}
				h4{
					font-weight: 400;
					padding: 0.1rem 0.12rem;
					line-height: 0.42rem;
					white-space: nowrap;
				}
			}
		}
		
		
	}
</style>

